import Validation from "./validation";
import {ValidationJson} from "./@types";
import {ValidationAction, ValidationTrigger} from "../../modules/validations/@const";
import {ConditionType} from "../conditions/condition-types";
import Collection from "../../data-structures/collection";


const debug = false
// const debug = "ValidationCollection"

export default class ValidationCollection extends Collection<Validation> {

    constructor(models:Validation[]) {

        debug && console.log(debug, "validations=", models);

        super(models);
    }

    static initFromSystemAndCustom(systemValidations: ValidationJson[], customValidations:ValidationJson[]):ValidationCollection {

        const models : Validation[] = []

        _.map(systemValidations, (data:ValidationJson)=>{
            models.push(new Validation(data))
        })

        _.map(customValidations, (data:ValidationJson)=>{
            models.push(new Validation(data))
        })


        return new ValidationCollection(models)
    }



    static initFromJson(validations: ValidationJson[]):ValidationCollection {

        const models : Validation[] = []

        _.map(validations, (data:ValidationJson)=>{
            models.push(new Validation(data))
        })


        return new ValidationCollection(models)
    }

    toJson(): ValidationJson[] {
        const result: any[] = []
        _.map(this.models, (validation:Validation)=>{

            // dont export system validartions
            if (validation.isSystem) return

            result.push(validation.toJSON())
        })

        return result
    }


}